/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import MagicLogin from "layouts/authentication/magic-login";
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import DemoCall from "layouts/authentication/demo";
import DemoBeta from "layouts/authentication/demo-beta";
import ContactUsPage from "layouts/contact";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import PersonIcon from "@mui/icons-material/Person";
import CallHistory from "./components/CallHistory";
import Reports from "./components/Reports";
import UserSettings from "./components/UserSettings";
// @mui icons
import Icon from "@mui/material/Icon";
import SettingsIcon from "@mui/icons-material/Settings";
import PhoneIcon from "@mui/icons-material/Phone";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SubscriptionPlans from "./components/SubscriptionPlans";
import ProfileScreen from "./components/ProfileScreen";
import VerificationScreen from "components/VerificationScreen";
import TrialProtectedRoute from "components/TrialProtectedRoute";
import EmailValidationPage from "components/EmailValidationPage";
import CallHistoryDistributor from "components/CallHistoryDistributor";

const routes = [
  {
    type: "collapse",
    name: "Call History",
    key: "callHistory",
    icon: <PhoneIcon />,
    route: "/callHistory",
    // component: <TrialProtectedRoute element={<UserSettings />} />,
    component: <CallHistory />, // ✅ wrapped
  },
  {
    type: "collapse",
    name: "Settings",
    key: "settings",
    icon: <SettingsIcon />,
    route: "/settings",
    component: <TrialProtectedRoute element={<UserSettings />} />, // ✅ wrapped
  },
  {
    type: "collapse",
    name: "Reports",
    key: "reports",
    icon: <AssessmentIcon />,
    route: "/reports",
    component: <Reports />, // ✅ wrapped
  },
  {
    type: "route",
    name: "Verification",
    key: "verification",
    route: "/verification",
    component: <VerificationScreen />,
  },
  {
    type: "route",
    name: "Call History Distributor",
    key: "call-history-distributor",
    route: "/call-history-distributor/:token",
    component: <MagicLogin />,
    isPublic: true,
    // component: <CallHistoryDistributor />,
  },
  {
    type: "collapse", // 👇 New subscription route
    name: "Plans",
    key: "plans",
    icon: <SubscriptionsIcon />,
    route: "/plans",
    component: <SubscriptionPlans />,
  },
  {
    type: "collapse", // 👇 New profile route
    name: "Profile",
    key: "profile",
    icon: <PersonIcon />,
    route: "/profile",
    component: <ProfileScreen />,
  },
  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up",
    component: <SignUp />,
  },
  // routes
  {
    type: "route",
    name: "Email Action",
    key: "email-action",
    route: "/v1/:action/:token", // <-- define :action and :token
    component: <EmailValidationPage />,
    isPublic: true,
  },
  {
    type: "route", // not shown in the sidebar
    name: "Magic Login",
    key: "magic-login",
    route: "/magic-login",
    component: <MagicLogin />,
  },
  {
    type: "route",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "route",
    name: "Demo",
    key: "demo",
    route: "/authentication/demo",
    component: <DemoCall />,
  },
  {
    type: "route",
    name: "Demo-Beta",
    key: "demo-beta",
    route: "/authentication/demo-beta",
    component: <DemoBeta />,
  },
];

export default routes;
